import { render, staticRenderFns } from "./RibbonCodes.vue?vue&type=template&id=697f0c77&scoped=true&"
import script from "./RibbonCodes.vue?vue&type=script&lang=js&"
export * from "./RibbonCodes.vue?vue&type=script&lang=js&"
import style0 from "./RibbonCodes.vue?vue&type=style&index=0&id=697f0c77&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "697f0c77",
  null
  
)

export default component.exports